import {forwardRef, useEffect, useRef, useState} from "react";
import {useLocation} from "react-use";
import {getTheme} from "@/Utility";
import {getLanguageCode} from "@/language";

const PagePdf = forwardRef((props, ref)=>{

    const params = useLocation();

    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [pdfInfo,setPdfInfo] = useState<any>({});

    useEffect(()=>{
        if (params.state?.usr?.pdfInfo){
            setPdfInfo(params.state.usr.pdfInfo);
            setTimeout(()=>{
                handleRender();
            },100)
        }
    },[params])


    const handleRender = () => {
        const iframe = document.getElementById("page-pdf-iframe") as HTMLIFrameElement;
        if (iframe) {
            iframe.contentWindow?.postMessage(JSON.stringify({
                path: pdfInfo.filePath,
                fileId: pdfInfo.fileId,
                type: "open-pdf",
                theme:getTheme(),
                language:getLanguageCode()
            }), {
                targetOrigin: '*'
            })

            if (pdfInfo.isViewAllHighlight){
                setTimeout(()=>{
                    iframe.contentWindow?._reader.toggleSidebar(true)
                },100)
            }

            // setTimeout(()=>{
            //     iframe.contentWindow._reader?._updateState({colorScheme: localStorage.getItem(SYS_CONFIG_KEY_THEME)??THEME_LIGHT})
            // },600)
        }
    }

    return(
        <div>
            <iframe
                ref={iframeRef}
                key={pdfInfo.filePath}
                id={"page-pdf-iframe"}
                src={"pdf/reader.html?type=pdf"}
                // src={"http://localhost:3001/dev/reader.html?type=pdf"}
                style={{
                    width: "100%",
                    height: '100%'
                }}
            />
        </div>
    )
})

export default PagePdf;